import { render, staticRenderFns } from "./ProjectVideo.vue?vue&type=template&id=6037c20f&scoped=true&"
import script from "./ProjectVideo.vue?vue&type=script&lang=ts&"
export * from "./ProjectVideo.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectVideo.vue?vue&type=style&index=0&id=6037c20f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6037c20f",
  null
  
)

export default component.exports